import React, { FC } from 'react';
import { BoxV2 as Box, Flex } from 'portal-commons';

interface Props {
  label: string;
  value: string;
  dataTestId?: string;
}

const FieldBlock: FC<Props> = ({ label, value, dataTestId }) => {
  return (
    <Flex
      data-testid={dataTestId}
      sx={{
        flexDirection: 'column',
        gap: 'xxs',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 'normal',
        color: '#19262A',
      }}
    >
      <Box
        data-testid={dataTestId && `${dataTestId}_label`}
        sx={{
          fontSize: '12px',
          color: '#4D5659',
          textTransform: 'uppercase',
          lineHeight: '20px',
        }}
      >
        {label}
      </Box>
      <Box
        data-testid={dataTestId && `${dataTestId}_value`}
        sx={{ wordBreak: 'break-all' }}
      >
        {value || 'N/A'}
      </Box>
    </Flex>
  );
};

export default FieldBlock;
